"use strict";
module.exports = function(config, get, post){
	return {
		create: createManageGroup,
		remove: removeManageGroup,
		update: updateManageGroup,
		list: listManageGroups,
		managers: {
			add: addManagerManageGroup,
			addAll: addAllManagersToManagerGroup,
			remove: removeManagerManageGroup,
			removeAll: removeAllManagersFromManagerGroup,
			list: listManagerManageGroup
		},
		patient: {
			list: listPatientsPatientGroup,
		},
		permissions: setPermissions,
		assignGroup: assignGroup,
		removeGroup: removeGroup,
		assignUsersToManageGroup: assignUsersToManageGroup,
		removeUsersFromManageGroups: removeUsersFromManageGroups,
		lock,
		unlock,
	};

	function createManageGroup(name, description){
		return post("/v2/org/managegroup/create", {
			name: name,
			description: description
		});
	}

	function removeManageGroup(groupId){
		return post("/v2/org/managegroup/remove", {
			group: groupId
		});
	}

	function updateManageGroup(groupId, name, description){
		return post("/v2/org/managegroup/update", {
			group: groupId,
			name: name,
			description: description
		});
	}

	function listManageGroups(){
		return get("/v2/org/managegroup/list");
	}

	function addManagerManageGroup(groupId, manager){
		return post("/v2/org/managegroup/manager/add", {
			group: groupId,
			manager: manager
		});
	}

	function removeManagerManageGroup(groupId, manager){
		return post("/v2/org/managegroup/manager/remove", {
			group: groupId,
			manager: manager
		});
	}

	function removeAllManagersFromManagerGroup(groupId, managerIds) {
		return post("/v2/org/managegroup/manager/removeAll", {
			group: groupId,
			managerIds: managerIds
		});
	}

	function addAllManagersToManagerGroup(groupId, managerIds) {
		return post("/v2/org/managegroup/manager/addAll", {
			group: groupId,
			managerIds: managerIds
		});
	}

	function listManagerManageGroup(groupId){
		return get("/v2/org/managegroup/manager/list", {
			group: groupId
		});
	}

	function setPermissions(group, permissions){
		return post("/v2/org/managegroup/setPermissions", {
			group: group,
			permissions: permissions
		});
	}

	function assignGroup(id, group, reassign){
		return post("/v2/org/managegroup/patient/assign", {
			who: id,
			group,
			reassign,
		});
	}

	function removeGroup(id, group){
		return post("/v2/org/managegroup/patient/remove", {
			who: id,
			group,
		});
	}

	function assignUsersToManageGroup(arrOfIds, group) {
		return post("/v2/org/managegroup/patient/assignMultiple", {
			arrOfIds,
			group
		});
	}

	function removeUsersFromManageGroups(arrOfIds) {
		return post("/v2/org/managegroup/patient/removeMultiple", {
			arrOfIds
		});
	}

	function listPatientsPatientGroup(patient){
		return get("/v2/org/managegroup/patient/list", {
			patient
		});
	}
	function lock(groupId){
		return post("/v2/org/managegroup/lock", {
			group: groupId,
			isLocked: true,
		});
	}

	function unlock(groupId){
		return post("/v2/org/managegroup/unlock", {
			group: groupId,
			isLocked: false,
		});
	}
};
